<template>
	<div style="width: 100%;">
		<!-- 头部标题区域 -->
		<!-- <div class="header-row">
			
			
		</div> -->

		<el-dialog title="新建课程" :visible.sync="isToClass" width="500px">
			<el-form label-width="100px">
				<el-form-item label="选择课程" prop="courseId">
					<el-select v-model="courseId" placeholder="请选择课程" clearable @change="forClass" style="width:100%">
						<el-option v-for="item in courseList" :key="item.id" :label="item.label" :value="item.id" />
					</el-select>
				</el-form-item>

				<el-form-item label="选择班级" prop="classId">
					<el-select v-model="classId" placeholder="请选择班级" :disabled="!courseId" @change="handleClassChange"
						style="width:100%">
						<el-option v-for="item in forclassList" :key="item.id" :label="item.label" :value="item.id" />
					</el-select>
				</el-form-item>

				<el-form-item label="课程名称" prop="courseName">
					<el-input v-model="courseName" placeholder="请输入课程名称" maxlength="20" show-word-limit
						style="width:100%" />
				</el-form-item>
			</el-form>

			<div slot="footer">
				<el-button @click="isToClass = false">取消</el-button>
				<el-button type="primary" @click="createClass(1)">创建进入课堂</el-button>
				<el-button type="primary" @click="createClass(2)">创建</el-button>
			</div>
		</el-dialog>

		<!-- 卡片列表外层 -->
		<div style="display: flex;padding-left: 20px;height: 40px;align-items: center;justify-content: space-between;">
			<!-- 左侧区域：标题+统计标签 -->
			<div style="display: flex;align-items: center;gap:12px;">
				<h3 style="margin: 0;">AI智能体课堂</h3>
				<div
					style="min-width: 40px;border-radius: 5px;background-color: #2b85e4;height: 20px;display:flex;align-items:center;justify-content:center;padding: 2px;">
					<i class="el-icon-s-grid" style="color: white;height: 20px;line-height: 20px;"></i>
					<span style="margin-left: 5px;color: white;line-height: 20px;">{{total}}</span>
				</div>
			</div>
			<!-- 右侧学期文字 -->
			<span v-if="semesterList.length>0" style="margin-right: 10px;font-weight: 800;color:#2b85e4">
				{{semesterArr.year}}--{{Number(semesterArr.year)+1}}学年{{semesterArr.term==1?'第一学期':'第二学期'}}
			</span>
		</div>
		<el-card style="margin-top:0px;" class="elcard">

			<!-- 滚动容器绑定滚动事件 -->
			<div class="card-wrapper" ref="scrollWrap" @scroll="handleScroll">
				<!-- 新增空白加号卡片 -->
				<div class="card-item add-card" @click="toClassview">
					<i class="el-icon-plus add-icon"></i>
					<div class="add-text">新建课程</div>
				</div>

				<!-- 课堂列表卡片 -->
				<div v-for="item in startClassList" :key="item.id" :class="['card-item', courseSubjectClass(item)]">
					<div v-if="courseSubjectLabel(item)" class="subject-pill">{{ courseSubjectLabel(item) }}</div>
					<div class="card-title" :title="item.courseName">{{ item.courseName }}</div>
					<div class="card-info">
						<div class="itemtitle">
							<span class="label">教 师:</span><span class="infoname"
								:title="item.teacherName">{{ item.teacherName || '未知老师' }}</span>
						</div>
						<div class="itemtitle">
							<span class="label">班 级:</span><span class="infoname"
								:title="item.className">{{ item.className }}</span>
						</div>
						<div class="itemtitle">
							<span class="label">学生数:</span><span class="infoname">{{item.studentCount}}</span>
						</div>
					</div>
					<!-- 时间按钮行移出card-info，同级放在最底部 -->
					<div class="time-row">
						<span>{{forTime(item.createTime) }}</span>
						<div class="card-action">
							

							<div style="display: flex;">
								<div v-if="item.status==1" title="继续上课"
									@click="toClass(item.id,item.courseName,item.customPageId,item.courseId)"
									style="width: 28px; height: 28px;"
									>
									<img src="@/ico/resumeClass.svg" style="width: 28px;height: 28px;" />
								</div>
								<div @click="toClassStatus(item)" title="开始上课" v-if="item.status==0">
									<img src="@/ico/classBegins.svg" style="width: 28px;height: 28px;" />
								</div>
								<div @click="supplementStudent(item)" title="补发学生"
									style="margin-left: 5px;width: 26px; height: 26px; background: #409EFF; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer;">
									<img src="@/ico/reissueStudent.svg" style="width: 20px;height: 20px;" />
								</div>
							</div>


						</div>
					</div>
				</div>

				<!-- 空数据提示 -->
				<div v-if="startClassList.length === 0 && !loading" class="empty-tip">
					暂无进行中的课堂
				</div>

				<!-- 加载中 -->
				<div v-if="loading" class="loading-tip">
					<i class="el-icon-loading"></i> 加载中...
				</div>

				<!-- 无更多数据 -->
				<div v-if="noMore && startClassList.length > 0" class="nomore-tip">
					没有更多数据了
				</div>
			</div>
		</el-card>
		<PostMessage v-if="postMessage"></PostMessage>
	</div>
</template>

<script>
	import {
		forGradeList,
		forSubjectList
	} from "@/js/standard.js";
	import TeacherVidos from "./teacherVidos.vue"
	import PostMessage from "../../../views/components/postMessage.vue"
	import {
		getUserClassList
	} from "@/js/userRole.js";
	import {
		userInfo
	} from "@/views/login.js"

	export default {
		components: {
			TeacherVidos,
			PostMessage
		},
		data() {
			return {
				courseId: '',
				classId: '',
				className: '三年级1班',
				classList: [],
				courseList: [],
				startClassList: [],
				schoolId: localStorage.getItem('orgId'),
				userId: localStorage.getItem('userId'),
				gradeList: [],
				forclassList: [],
				subjectList: [],
				courseName: '',
				isToClass: false,
				// 无限滚动分页参数
				pageNum: 1,
				pageSize: 10,
				total: 0,
				totalCont: 0,
				loading: false,
				noMore: false,
				semesterList: [],
				semesterArr: {},
				postMessage: false,
				isCreated: false,
				login:null,
			}
		},
		created() {
			this.GradeList()
			this.toSubjectList()
			this.getCourseList()
			this.info()
			this.resetPageLoad()


		},
		mounted() {
			const script = document.createElement('script');
			script.src = 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/builder-web-sdk/0.1.0/dist/umd/index.js';
			script.onload = () => {
				new CozeWebSDK.AppWebSDK({
					token: "pat_4Rzm9exMbIXvxCr078pmMiyyJi2Wl7c9VTl4ELG7iCVoLfj3bfoc7dv2PqctthtG",
					appId: "7634110409594716186",
					container: document.getElementById("coze-app"),
					userInfo: {
						userId: "user_123456",
						nickname: "测试用户",
						avatar: ""
					}
				});
			};
			document.head.appendChild(script);
		},
		methods: {
			courseSubjectValue(item = {}) {
				if (item.subjectName || item.subject) return item.subjectName || item.subject
				const subjectId = item.subjectId || item.courseSubjectId
				if (subjectId) return subjectId
				const course = this.courseList.find(v => String(v.id) === String(item.courseId))
				if (course) return course.subjectName || course.subjectLabel || course.subject || course.subjectId
				return ''
			},
			courseSubjectLabel(item = {}) {
				const value = this.courseSubjectValue(item)
				if (!value) return ''
				const text = String(value).trim()
				if (/^\d+$/.test(text)) {
					const subject = this.subjectList.find(v => String(v.id) === text || String(v.value) === text)
					return subject ? (subject.label || subject.name || subject.subjectName || '') : ''
				}
				return text
			},
			courseSubjectClass(item = {}) {
				const text = `${this.courseSubjectLabel(item)} ${item.courseName || ''}`
				if (/英语|英文|English|单词|口语|听力|字母/i.test(text)) return 'subject-english'
				if (/语文|國文|作文|阅读|朗读|诗词|古诗/.test(text)) return 'subject-chinese'
				if (/数学|算术|几何|代数|口算|π|函数/.test(text)) return 'subject-math'
				if (/科学|物理|化学|生物|实验|自然|科学课|stem/i.test(text)) return 'subject-science'
				if (/美术|艺术|绘画|书法/.test(text)) return 'subject-art'
				if (/音乐|声乐|合唱|乐理/.test(text)) return 'subject-music'
				if (/体育|运动|体能|足球|篮球|跑步/.test(text)) return 'subject-pe'
				return 'subject-default'
			},
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			supplementStudent(row) {
				this.loginOpen('补发学生中...')
				this.API.post(this.API.school.postSupplementStudent, {
					courseClassId:row.id
				}).then(res => {
					
					this.$message.success(res.data.data)
					this.noLogin()
				}).catch(err => {
					this.$message.error("补发失败")
					this.noLogin()
				})
			},
			// 重置分页重新加载第一页
			resetPageLoad() {
				this.pageNum = 1
				this.startClassList = []
				this.noMore = false
				this.loading = false
				this.getTeacherClassStatus(1, this.pageNum, this.pageSize, true)
			},
			// 滚动监听触底加载
			handleScroll() {
				// console.log('33333')
				// if(!this.isCreated) return 
				const wrap = this.$refs.scrollWrap;
				if (!wrap || this.loading || this.noMore) return;
				const scrollTop = wrap.scrollTop;
				const wrapHeight = wrap.clientHeight;
				const allHeight = wrap.scrollHeight;

				// 内容没超出容器，无滚动条，直接退出，交给自动填充逻辑处理
				if (allHeight <= wrapHeight) return;

				// 距离底部100px触发加载
				if (scrollTop + wrapHeight + 100 >= allHeight) {
					this.pageNum++;
					this.getTeacherClassStatus(1, this.pageNum, this.pageSize, false);
				}
			},
			ispostMessage() {
				this.$router.push({
					path: '/teacher/postMessage',
				})
			},
			semester() {
				if (localStorage.getItem('semester')) {
					this.semesterList = JSON.parse(localStorage.getItem('semester'))
					this.semesterArr = this.semesterList?.filter(v => v.status == 1)[0]
				} else {
					this.semesterList = []
					this.semesterArr = {}
				}
			},
			forTime(timestamp) {
				if (!timestamp) return ''
				const date = new Date(timestamp)
				const y = date.getFullYear()
				const m = (date.getMonth() + 1).toString().padStart(2, '0')
				const d = date.getDate().toString().padStart(2, '0')
				const hh = date.getHours().toString().padStart(2, '0')
				const mm = date.getMinutes().toString().padStart(2, '0')
				const ss = date.getSeconds().toString().padStart(2, '0')
				return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
			},
			toClassview() {
				this.className = ''
				this.courseId = ''
				this.classId = ""
				this.courseName = ""
				this.isToClass = true
			},
			async info() {
				await userInfo()
				this.semester()
			},
			handleClassChange(val) {
				if (!val) {
					this.className = '';
					return
				}
				let item = this.classList.find(v => v.id == val)
				if (item) this.className = item.label
			},
			forSubjectName(v) {
				let obj = this.subjectList.find(i => i.value == v)
				return obj ? obj.label : ''
			},
			toSubjectList() {
				this.subjectList = forSubjectList()
			},
			forGradeName(v) {
				let obj = this.gradeList.find(i => i.value == v)
				return obj ? obj.label : ''
			},
			async GradeList() {
				this.gradeList = forGradeList()
				let t = await getUserClassList(this.API)
				let classList = JSON.stringify(t)
				localStorage.setItem('classList', classList)
			},
			async getCourseList() {
				try {
					const res = await this.API.get(this.API.admin.getCourseList, {
						pageNum: 1,
						pageSize: 100,
						status: 1,
						schoolId: this.schoolId
					})
					this.courseList = res.data.data.records.filter(v => v.status == 0).map(v => ({
						...v,
						label: `${v.courseName}-${this.forGradeName(v.grade)}-${this.forSubjectName(v.subject)}`
					}))
				} catch (e) {
					this.courseList = []
				}
			},
			forClass() {
				if (!this.courseId) return
				let g = this.courseList.find(v => v.id == this.courseId)
				if (g) this.forClassList(g.grade)
			},
			forClassList(grade) {
				this.API.get(this.API.school.getSchoolGradClass, {
						schoolId: this.schoolId,
						gradeId: grade
					})
					.then(res => {
						this.classList = res.data.data.map(v => ({
							...v,
							label: `${this.forGradeName(v.initGrade)}-${v.classAlias}`
						}))
						this.forclassList = this.classList
					})
			},
			// status=1进行中课堂
			getTeacherClassStatus(status, pageNum, pageSize, isReset) {
				this.loading = true
				this.API.post(this.API.school.getTeacherClassList, {
					schoolId: localStorage.getItem('orgId'),
					teacherId: localStorage.getItem('userId'),
					courseStatus: status,
					pageNum,
					pageSize
				}).then(async res => {
					this.loading = false
					const records = res.data.data.records || []
					this.total = res.data.data.total || 0
					if (isReset) {
						this.startClassList = records
					} else {
						this.startClassList = [...this.startClassList, ...records]
					}
					// 判断是否无更多数据
					if (this.startClassList.length >= this.total) {
						this.noMore = true
						return
					}
					// 等待DOM渲染完成
					await this.$nextTick()
					const wrap = this.$refs.scrollWrap
					// 内容高度 ≤ 可视高度，自动加载下一页
					setTimeout(() => {
						this.isCreated = true
					}, 1000)
					if (wrap.scrollHeight <= wrap.clientHeight) {
						this.pageNum++
						this.getTeacherClassStatus(1, this.pageNum, this.pageSize, false)
					}
				}).catch(() => {
					this.loading = false
				})
			},
			async createClass(val) {
				if (!this.courseId || !this.classId || !this.courseName) {
					return this.$message.warning('信息不全')
				}
				let course = this.courseList.find(v => v.id === this.courseId)
				const {
					data
				} = await this.API.post(this.API.school.postSchoolClasscreate, {
					schoolId: localStorage.getItem('orgId'),
					courseName: this.courseName,
					courseId: this.courseId,
					customPageId: course.customPageId,
					classId: this.classId,
					gradeId: Number(course.grade),
					subjectId: Number(course.subject),
					schoolSemesterId: this.semesterArr.id,
					year: this.semesterArr.year,
					term: this.semesterArr.term,
					className: this.className,
					teacherId: localStorage.getItem('userId'),
					status: val === 1 ? 1 : 0
				})
				const id = data.data
				if (val === 1) {
					this.toClass(id, course.courseName, course.customPageId, this.courseId)
				} else {
					this.resetPageLoad()
					this.isToClass = false
				}
			},
			toClassStatus(item) {
				this.API.post(this.API.school.postSchoolClasscreateStart, {
					courseClassId: item.id,
					teacherId: this.userId
				}).then(res => {
					if (res.data.code == 200) {
						this.$message.success('开课成功')
						this.toClass(item.id, item.courseName, item.customPageId, item.courseId)
					} else {
						this.$message.error('开课失败')
					}
				}).catch(error => {
					this.$message.error('开课失败')
				})
			},
			toClass(courseClassId, courseName, customPageId, courseId) {
				localStorage.setItem('courseClassId', courseClassId)
				localStorage.setItem('customPageId', customPageId)
				localStorage.setItem('courseId', courseId)
				localStorage.setItem('isSave', false)
				this.$router.push({
					path: '/teacher/interactiveClassroom',
					query: {
						courseClassId,
						courseName
					}
				})
			}
		}
	}
</script>
<style>
	.el-container {
		box-sizing: border-box;
	}
</style>
<style scoped>
	.header-row {
		display: flex;
		align-items: center;
		gap: 16px;
		margin-bottom: 10px;
	}

	.header-row h2 {
		margin: 0;
		line-height: 1;
	}

	.elcard {
		width: 100% !important;
		box-sizing: border-box;
	}

	.elcard>>>.el-card__body {
		padding: 0 !important;
	}

	/* 滚动网格容器 */
	.card-wrapper {
		width: 100%;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
		gap: 8px 16px;
		margin-top: 15px;
		max-height: calc(80vh);
		overflow-y: auto;
		padding: 0 20px 10px 20px;
		/* 保证滚动高度正常计算 */
		min-height: 100px;
	}

	/* 卡片核心修复：justify-content:flex-start 不再居中挤压内容 */
	.card-item {
		position: relative;
		overflow: hidden;
		background: linear-gradient(135deg, #ffffff 0%, #f8fbff 48%, #eef7ff 100%);
		border-radius: 10px;
		padding: 12px 18px;
		box-shadow: 0 10px 28px rgba(31, 65, 105, 0.08);
		border: 1px solid rgba(126, 154, 186, 0.16);
		min-height: 180px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
		/* 修复1：内容靠上，滚动高度正常 */
	}

	.card-item:hover {
		transform: translateY(-2px);
		box-shadow: 0 16px 36px rgba(31, 65, 105, 0.13);
		border-color: rgba(64, 158, 255, 0.26);
	}

	.card-item::before,
	.card-item::after {
		position: absolute;
		pointer-events: none;
		z-index: 0;
	}

	.card-item::before {
		content: "";
		inset: 0;
		background: radial-gradient(circle at 88% 12%, rgba(255, 255, 255, .9), transparent 26%);
	}

	.card-item::after {
		content: "AI";
		right: 18px;
		top: 12px;
		font-size: 42px;
		font-weight: 800;
		line-height: 1;
		color: rgba(64, 158, 255, .14);
	}

	.card-item>* {
		position: relative;
		z-index: 1;
	}

	.card-item:has(.card-title[title*="语文"]),
	.card-item:has(.card-title[title*="作文"]),
	.card-item:has(.card-title[title*="阅读"]),
	.subject-chinese {
		background: linear-gradient(135deg, #ffffff 0%, #fff8fa 48%, #ffe8ee 100%);
	}

	.card-item:has(.card-title[title*="语文"])::after,
	.card-item:has(.card-title[title*="作文"])::after,
	.card-item:has(.card-title[title*="阅读"])::after,
	.subject-chinese::after {
		content: "文";
		color: rgba(180, 71, 92, .15);
	}

	.card-item:has(.card-title[title*="数学"]),
	.card-item:has(.card-title[title*="几何"]),
	.card-item:has(.card-title[title*="口算"]),
	.subject-math {
		background: linear-gradient(135deg, #ffffff 0%, #f7fbff 48%, #dff1ff 100%);
	}

	.card-item:has(.card-title[title*="数学"])::after,
	.card-item:has(.card-title[title*="几何"])::after,
	.card-item:has(.card-title[title*="口算"])::after,
	.subject-math::after {
		content: "π";
		color: rgba(45, 117, 184, .16);
	}

	.card-item:has(.card-title[title*="英语"]),
	.card-item:has(.card-title[title*="English"]),
	.card-item:has(.card-title[title*="单词"]),
	.subject-english {
		background: linear-gradient(135deg, #ffffff 0%, #f5fffb 48%, #ddf7ed 100%);
	}

	.card-item:has(.card-title[title*="英语"])::after,
	.card-item:has(.card-title[title*="English"])::after,
	.card-item:has(.card-title[title*="单词"])::after,
	.subject-english::after {
		content: "A";
		color: rgba(27, 138, 114, .16);
	}

	.card-item:has(.card-title[title*="科学"]),
	.card-item:has(.card-title[title*="实验"]),
	.card-item:has(.card-title[title*="物理"]),
	.card-item:has(.card-title[title*="化学"]),
	.card-item:has(.card-title[title*="生物"]),
	.subject-science {
		background: linear-gradient(135deg, #ffffff 0%, #faf9ff 48%, #eceaff 100%);
	}

	.card-item:has(.card-title[title*="科学"])::after,
	.card-item:has(.card-title[title*="实验"])::after,
	.card-item:has(.card-title[title*="物理"])::after,
	.card-item:has(.card-title[title*="化学"])::after,
	.card-item:has(.card-title[title*="生物"])::after,
	.subject-science::after {
		content: "⚗";
		color: rgba(109, 91, 208, .16);
	}

	.subject-art {
		background: linear-gradient(135deg, #ffffff 0%, #fffaf4 48%, #ffefde 100%);
	}

	.subject-art::after {
		content: "艺";
		color: rgba(194, 96, 40, .16);
	}

	.subject-music {
		background: linear-gradient(135deg, #ffffff 0%, #fbf7ff 48%, #f4e8ff 100%);
	}

	.subject-music::after {
		content: "♪";
		color: rgba(140, 87, 184, .16);
	}

	.subject-pe {
		background: linear-gradient(135deg, #ffffff 0%, #f8fff6 48%, #e5f8e1 100%);
	}

	.subject-pe::after {
		content: "动";
		color: rgba(47, 138, 62, .16);
	}

	.subject-pill {
		align-self: flex-start;
		max-width: 100%;
		min-height: 22px;
		padding: 3px 9px;
		margin: -2px 0 8px;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.72);
		border: 1px solid rgba(64, 158, 255, .18);
		color: #2777d8;
		font-size: 12px;
		font-weight: 700;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		box-shadow: 0 4px 12px rgba(31, 65, 105, 0.05);
	}

	/* 底部栏自动推到卡片最底端 */
	.time-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: auto;
		/* 修复2：自动挤到卡片底部 */
		margin-top: auto;
		padding-top: 8px;
	}

	.add-card {
		border: 1px dashed #c0c4cc;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #999;
		transition: all 0.2s;
		background: linear-gradient(135deg, #ffffff, #f4f9ff);
		box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .6), 0 10px 24px rgba(31, 65, 105, .06);
	}

	.add-card:hover {
		border-color: #409eff;
		color: #409eff;
	}

	.add-icon {
		font-size: 32px;
		margin-bottom: 8px;
	}

	.add-text {
		font-size: 14px;
	}

	.card-title {
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 10px;
		color: #409EFF;
		max-width: 300px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.card-info {
		font-size: 13px;
		color: #666;
		line-height: 1.6;
		margin-bottom: 8px;
		flex: 1;
		/* 占满剩余空间，把time-row压到底 */
	}

	.card-action {
		text-align: right;
		margin-top: 0;
	}

	.itemtitle {
		font-size: 16px;
		display: flex;
	}

	.label {
		width: 60px;
		padding-right: 8px;
		flex-shrink: 0;
		/* 关键：分散对齐 */
		text-align: justify;
		/* 修复单行justify不生效 */
		text-align-last: justify;
		display: inline-block;
	}

	.infoname {
		font-weight: 500;
		max-width: 220px;
		/* 自定义限制宽度 */
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}

	.empty-tip,
	.loading-tip,
	.nomore-tip {
		grid-column: 1 / -1;
		text-align: center;
		padding: 40px 0;
		color: #999;
		font-size: 13px;
	}

	/* 滚动条美化 */
	.card-wrapper::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.card-wrapper::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background: #cbd5e1;
	}

	.card-wrapper::-webkit-scrollbar-track {
		background: #f1f5f9;
		border-radius: 3px;
	}
</style>
